
import Vue from 'vue';
import raven from '@/modules/raven';
// import { State } from '@/stores/auth';

// declare module 'vue/types/vue' {
//   interface Vue {
//     $auth: State;
//   }
// }
export default Vue.extend({
  methods: {
    $fatal(error: Error) {
      // console.error(error);
      raven.captureException(error);
      this.$stores.notifications.addErrorNotification('データをの読み込みに失敗しました。ブラウザをリロードしてください。問題が解決しない場合はサポートまで連絡をお願いします。');
    },
    $error(text: string, error?: Error | null) {
      // console.error(error);
      if (error) {
        raven.captureException(error);
      }
      this.$stores.notifications.addErrorNotification(text);
    },
    $success(text: string) {
      this.$stores.notifications.addSuccessNotification(text);
    },
  },
});
